import React, { useMemo, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import { CurrentStoreContext } from '../../../controller/StoreController';
import moment from 'moment-timezone';
import CheckoutDetailModal from '../../../components/modal/CheckoutDetailModal';
import {
  CheckoutHistoryDetailType,
  CheckoutHistoryType,
} from '../../../controller/CheckoutController';

interface CheckoutListItemProps {
  item: CheckoutHistoryType;
  getHotelNoticeHistoryDetail: any;
}

const CheckoutListItem = ({ item, getHotelNoticeHistoryDetail }: CheckoutListItemProps) => {
  const [noticeDetail, setNoticeDetail] = useState<CheckoutHistoryDetailType>();
  const [visibleDetail, setVisibleDetail] = useState<boolean>(false);

  const getHotelNoticeDetail = async () => {
    const oRes = await getHotelNoticeHistoryDetail(item.representLogId);
    if (oRes) {
      setNoticeDetail(oRes);
      setVisibleDetail(true);
    }
  };

  return (
    <>
      <Style>
        <div className="itemWrap">
          <div className="row gap">
            <div className="listItem">
              <h4>{moment(new Date(item.noticeExpectedAt)).format('HH:mm')}</h4>
              <p>{moment(new Date(item.noticeExpectedAt)).format('YYYY-MM-DD')}</p>
            </div>
            <div className="listItem info">
              <div className="row">
                <h4 className="title">{item.noticeTypeStr}</h4>
                {item.noticeTotalCount - item.noticeCheckedCount > 0 && (
                  <div className="badge">
                    <img src={`${process.env.PUBLIC_URL}/svg/ic_close_red_box.svg`} alt="img" />
                    <h5>{`응답없는 객실 : ${
                      item.noticeTotalCount - item.noticeCheckedCount
                    }개`}</h5>
                  </div>
                )}
              </div>
              <h4>{item.content}</h4>
            </div>
          </div>
          <button className="detailButton" onClick={getHotelNoticeDetail}>
            <p>상세</p>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_right.svg`} alt="img" />
          </button>
        </div>
      </Style>
      {noticeDetail && (
        <CheckoutDetailModal
          isVisible={visibleDetail}
          setVisible={setVisibleDetail}
          item={noticeDetail}
        />
      )}
    </>
  );
};

export default CheckoutListItem;

const Style = styled.div`
  .itemWrap {
    display: flex;
    justify-content: space-between;
    padding: 30px 10px;
    gap: 30px;
    border-bottom: 1px solid #e5e5e5;
  }
  .row.gap {
    gap: 30px;
  }

  .listItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    h4 {
      color: #979797;
    }
    p {
      line-height: 20px;
      color: #979797;
    }
  }
  .listItem.info {
    align-items: flex-start;
    h4 {
      font-size: 16px;
      line-height: 24px;
      white-space: pre-line;
      font-weight: 400;
    }
    .title {
      line-height: 28px;
      font-weight: 600;
      color: #555555;
    }
  }

  .detailButton {
    height: min-content;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 8px 6px 12px;
    border: 1px solid #cecece;
    border-radius: 50px;

    p {
      font-size: 12px;
      line-height: 14px;
      color: #999999;
    }
    img {
      height: 14px;
    }
  }

  .badge {
    margin-left: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
    background: #ffebed;
    border-radius: 50px;
    padding: 4px 16px;

    h5 {
      font-weight: 600;
      line-height: 16px;
      color: #ff6060;
    }
  }

  @media (max-width: 900px) {
    .itemWrap {
      padding: 20px 10px;
      gap: 20px;
    }
    .row.gap {
      gap: 20px;
    }

    .listItem {
      h4 {
        font-size: 14px;
      }
      p {
        font-size: 10px;
        line-height: 16px;
        white-space: nowrap;
      }
    }
    .listItem.info {
      h4 {
        font-size: 14px;
        line-height: 18px;
      }
    }

    .detailButton {
      padding: 3px 4px 3px 8px;
    }
  }
`;
